module.exports = __webpack_public_path__ + "img/toronto.51f397cb.png";